export const getChapterContentId = (ficId: string, chapterId: string) => `${ficId}@${chapterId}`;